import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Spinner } from 'triider-components';

import CardOpenOrders from 'components/CardOpenOrders';

import { 
  Container, MessageQuantTasks, IconStatusTask, ContentSpinner,
} from './styles';

function ContainerOrders() {
  const [showTasks, setShowTasks] = useState(true);
  const tasks = useSelector(state => state.task.data);
  const loadingVisible = useSelector(state => state.ui.loaders.includes('TASK'));

  return (
    <Container>
      {loadingVisible ? (
        <ContentSpinner>
          <Spinner size="small" />
        </ContentSpinner>
      ) : (
        <MessageQuantTasks
          onClick={tasks.length > 0 ? (() => setShowTasks(!showTasks)) : undefined}
          expanded={showTasks}
          show={tasks.length > 0}
        >
          <IconStatusTask status={tasks.length} />
          {
            tasks.length > 0 ? (
              `Você tem ${tasks.length} pedidos em andamento`
            ) : (
              'Você não possui pedido em andamento'
            )
          }
        </MessageQuantTasks>
      )}
      {
        showTasks && tasks.length > 0 && (
          tasks.map(task => task && <CardOpenOrders key={task.task_id} task={task} />)
        )
      }
    </Container>
  );
}

export default ContainerOrders;
